import target from './target';
import items from './items';
import entering from './entering';
import result from './result';
import audit from './audit';
import course from './course';
import enteringAudit from './entering-audit';
import resultAudit from './result-audit';
import all from './all';
import view from './view'
import majorSort from './major-sort';
import swot from './swot';
import earlywarning from './earlywarning';
import resultOwn from './result-own';
import majorSortWarn from './major-sort-warn';

export default {
    target,
    items,
    entering,
    result,
    audit,
    course,
    enteringAudit,
    resultAudit,
    all,
    view,
    majorSort,
    swot,
    earlywarning,
    resultOwn,
    majorSortWarn
}